import React from "react";

function Aviso() {
  return (
    <main>
      <div
        style={{ paddingTop: "40px"}}
      >
        <h3 align="center">Aviso de Privacidad</h3>

        <br />
        <br />

        <div class="row">
          <div class="col-xs-12 offset-md-2 col-md-8">
            <p>
              El presente Aviso de Privacidad se emite en cumplimiento de la Ley
              Federal de Protección de Datos Personales en Posesión de los
              Particulares.
            </p>
            <br />

            <p style={{fontWeight:"bolder"}}>Responsable de la Protección de Datos Personales:</p>
            <ul style={{ listStyle: "none" }}>
              <li>Flagacan</li>
              <li>Teléfono: 55 5010 8700</li>
              <li>contacto@flagasa.com</li>
            </ul>

            <br />
            <p style={{fontWeight:"bolder"}}>Finalidades del Tratamiento de Datos Personales:</p>
            <p>
              Los datos personales recopilados durante el proceso de registro
              para el Concurso de Fotos de Perritos en Guadalajara serán
              utilizados única y exclusivamente para los siguientes fines:
            </p>
            <ul style={{ listStyle: "none" }}>
              <li>
                - Verificación de elegibilidad para participar en el concurso.
              </li>
              <li>
                - Comunicación con los participantes respecto a la
                administración del concurso, anuncios de ganadores, y entrega de
                premios.
              </li>
              <li>
                - Publicación del nombre del ganador en nuestras redes sociales
                y página web.
              </li>
            </ul>

            <br />
            <p style={{fontWeight:"bolder"}}>Datos Personales Recopilados:</p>
            <p>
              Durante el registro para el concurso, se podrán recopilar los
              siguientes datos personales:
            </p>
            <ul style={{ listStyle: "none" }}>
              <li>- Nombre completo</li>
              <li>- Dirección de correo electrónico</li>
              <li>- Nombre de usuario en Instagram</li>
              <li>
                - Fotografía del perrito participante (en caso de que se
                solicite)
              </li>
            </ul>

            <br />
            <p style={{fontWeight:"bolder"}}>Transferencia de Datos Personales:</p>
            <p>
              Los datos personales recopilados durante el proceso de registro no
              serán transferidos a terceros, salvo requerimiento legal por parte
              de autoridades competentes.
            </p>

            <br />
            <p style={{fontWeight:"bolder"}}>Medidas de Seguridad:</p>
            <p>
              Se implementarán medidas de seguridad administrativas, técnicas y
              físicas para proteger los datos personales recopilados y evitar su
              acceso no autorizado, uso indebido o divulgación.
            </p>

            <br />
            <p style={{fontWeight:"bolder"}}>Derechos ARCO:</p>
            <p>
              Los participantes tienen derecho a acceder, rectificar, cancelar u
              oponerse al tratamiento de sus datos personales, así como revocar
              el consentimiento otorgado para su tratamiento, a través de los
              medios establecidos en este Aviso de Privacidad.
            </p>

            <br />
            <p style={{fontWeight:"bolder"}}>Cambios al Aviso de Privacidad:</p>
            <p>
              Nos reservamos el derecho de realizar modificaciones o
              actualizaciones al presente Aviso de Privacidad, las cuales serán
              notificadas a través de nuestros medios de comunicación
              habituales.
            </p>

            <br />
            <p style={{fontWeight:"bolder"}}>Contacto:</p>
            <p>
              Para cualquier duda o aclaración respecto al tratamiento de datos
              personales, los participantes pueden ponerse en contacto con
              nosotros a través de los datos de contacto proporcionados
              anteriormente.
            </p>

            <br />
            <p>
              Al participar en el Concurso de Fotos de Perritos en Guadalajara,
              los participantes aceptan los términos y condiciones establecidos
              en este Aviso de Privacidad.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Aviso;
